<dgx-components-panel
  *ngIf="planDetails"
  [border]="border"
  [rounded]="rounded"
  [variant]="variant"
>
  <h2 class="mb-4 typog-h3">
    {{ 'SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TITLE' | translate }}
  </h2>

  <dgx-components-description-list>
    <dgx-components-description-list-item
      *ngIf="registrationDetails?.type"
      [data]="registrationDetails?.type"
      [spaced]="true"
      [stacked]="stacked"
      [title]="'SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_APPLIANCE' | translate"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      [data]="planDetails.planNumber"
      [spaced]="true"
      [stacked]="stacked"
      [title]="'SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_NUMBER' | translate"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="planDetails.effectiveDate"
      [data]="planDetails.effectiveDate | dateFormat : 'MM-dd-yyyy'"
      [leftIcon]="'calendar'"
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        'SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_START_DATE' | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="planDetails.price"
      [data]="
        isAnnualPlan
          ? (planDetailsAnnualPrice | currencyFormat)
          : (planDetails.price | currencyFormat)
      "
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        isAnnualPlan
          ? ('SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_ANNUAL_PAYMENT'
            | translate)
          : ('SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_MONTHLY_PAYMENT'
            | translate)
      "
      [variant]="'bordered'"
    />
  </dgx-components-description-list>

  <div class="registration-confirmation-plan-panel__additional-content mt-4">
    <p *ngIf="termsAndConditionsWib; else termsAndConditions">
      Applicable taxes calculated monthly. <br />
      Details on your discount, if applicable, are included in your plan
      document.
      <br />
      Charges will appear on your billing statement as 'D&G Svc Plan'.
    </p>

    <a
      *ngIf="applianceTermsAndConditions"
      href="{{ applianceTermsAndConditions }}"
      class="registration-confirmation-plan-panel__terms-and-conditions mt-4"
      target="_blank"
    >
      {{
        'SHARED_UI_REGISTRATION_CONFIRMATION_PLAN_TERMS_AND_CONDITIONS'
          | translate
      }}</a
    >
  </div>
</dgx-components-panel>

<ng-template #termsAndConditions>
  <p class="'mt-4">
    Applicable taxes calculated monthly. Your discounted rate is shown above.
    Your plan documents (which we've emailed to you) contain the full breakdown
    of your payment plus any applicable taxes. Charges will appear on your
    billing statement as 'D&G Svc Plan'.
  </p>
</ng-template>
